module.exports = __webpack_public_path__ + "img/domotica.5eb14117.svg";